'use strict';

const rolePermissions = new Map();
// Guest
rolePermissions.set('guest', [
  'access',
  'help',
  'home',
  'forgot-password',
  'login',
  'signup',
  'event.list',
  'event.detail',
  'event.angler.list',
  'event.draw.list',
  'event.draw.export-pdf',
  'event.group.list',
  'event.registration.list',
  'event.result.list',
  'event.result.group',
  'event.result.sector',
  'event.results.export-pdf',
  'event.rotation.list',
  'event.score.list',
  'event.sector.list',
  'event.session.list',
  'event.team.list',
  'league.list',
  'league.detail',
]);

// Member
rolePermissions.set('member', [
  // Merge in guest
  ...rolePermissions.get('guest'),
  'account',
  'account.change-password',
  'account.organizer',
  'account.event.organized.list',
  'event.registration.register',
  'event.registration.confirm',
  'profile.detail',
  'profile.event.organized.list',
  'profile.event.result.list',
]);

// Organizer
rolePermissions.set('organizer', [
  // Merge in member
  ...rolePermissions.get('member'),
  'event.add',
  'event.manage.edit',
  'event.manage.detail',
  'event.manage.logo',
  'event.manage.angler.list',
  'event.manage.angler.detail',
  'event.manage.angler.add',
  'event.manage.angler.edit',
  'event.manage.angler.delete',
  'event.manage.angler.transfer',
  'event.manage.draw.list',
  'event.manage.draw.detail',
  'event.manage.draw.add',
  'event.manage.draw.edit',
  'event.manage.draw.delete',
  'event.manage.group.list',
  'event.manage.group.draw',
  'event.manage.group.detail',
  'event.manage.group.add',
  'event.manage.group.edit',
  'event.manage.group.delete',
  'event.manage.registration.list',
  'event.manage.registration.edit',
  'event.manage.registration.delete',
  'event.manage.result.list',
  'event.manage.result.group',
  'event.manage.result.calculate',
  'event.manage.rotation.list',
  'event.manage.rotation.detail',
  'event.manage.rotation.add',
  'event.manage.rotation.edit',
  'event.manage.rotation.delete',
  'event.manage.rotation.save',
  'event.manage.score.list',
  'event.manage.score.detail',
  'event.manage.score.add',
  'event.manage.score.edit',
  'event.manage.score.delete',
  'event.manage.sector.list',
  'event.manage.sector.detail',
  'event.manage.sector.add',
  'event.manage.sector.edit',
  'event.manage.sector.delete',
  'event.manage.security.list',
  'event.manage.security.add',
  'event.manage.security.delete',
  'event.manage.session.list',
  'event.manage.session.add',
  'event.manage.session.edit',
  'event.manage.session.delete',
  'event.manage.setting.edit',
  'event.manage.team.list',
  'event.manage.team.detail',
  'event.manage.team.add',
  'event.manage.team.edit',
  'event.manage.team.delete',
  'league.manage.detail',
  'league.manage.edit',
  'league.manage.security.list',
  'league.manage.security.add',
  'league.manage.security.edit',
  'league.manage.security.delete',
  'species.list',
]);

// Admin
rolePermissions.set('administrator', [
  // Merge in organizer
  ...rolePermissions.get('organizer'),
  'species.add',
  'species.edit',
  'species.delete',
  'user.list',
  'user.detail',
  'user.add',
  'user.edit',
  'user.delete',
]);

//console.log(rolePermissions);
export default rolePermissions;
